<template>
  <div>
    <Modal v-model="visible" width="800px" title="新增" :footer-hide="true" :mask-closable="false" class="my-modal">
      <Form ref="form" :model="formData" :label-width="120" class="page-form less">
        <FormItem prop="policyNo" label="保单号" :rules="$units.formRule.required('请输入')">
          <Input
            v-model.trim="formData.policyNo"
            placeholder="请先输入保单号校验"
            @on-change="
              loadPolicy = false;
              getPolicy();
            "
          />
        </FormItem>
        <FormItem label="机构">
          <Input :value="formData.orgName" placeholder="输入保单号校验后回显" disabled />
        </FormItem>
        <FormItem label="团队">
          <Input :value="formData.groupName" placeholder="输入保单号校验后回显" disabled />
        </FormItem>
        <FormItem label="业务员">
          <Input :value="formData.salesmanName" placeholder="输入保单号校验后回显" disabled />
        </FormItem>
        <FormItem label="投保产品" class="full">
          <Input :value="formData.productName" placeholder="输入保单号校验后回显" disabled />
        </FormItem>
        <FormItem label="投保人姓名">
          <Input :value="formData.holderName" placeholder="输入保单号校验后回显" disabled />
        </FormItem>
        <FormItem label="收件人姓名" prop="receiveName" :rules="$units.formRule.required('请输入收件人姓名')">
          <Input v-model="formData.receiveName" placeholder="请输入收件人姓名" />
        </FormItem>
        <FormItem label="收件人手机号" prop="receiveMoblie" :rules="formData.eyeShow?[$units.formRule.required('请输入收件人手机号'),$units.formRule.tel()]:{required:true, message: '请输入收件人手机号'}">
          <div class="tips">
            <Input v-model="formData.receiveMoblie" v-if="formData.eyeShow || !mobileEye" placeholder="请输入收件人手机号" @on-change="dataChange($event)" />
            <Input v-model="formData.receiveMoblie1" v-else placeholder="请输入收件人手机号" @on-change="dataChange($event)" />
            <span v-if="mobileEye &&formData.receiveMoblie1">
              <i class="iconfont iconxianshi eye-icon" v-if="formData.eyeShow" @click="openEye(formData,'eyeShow','receiveMoblie')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(formData,'eyeShow','receiveMoblie')"></i>
            </span>
          </div>
        </FormItem>
        <FormItem label="收件人和投保人的关系" prop="relationship" :rules="$units.formRule.required('请选择收件人和投保人的关系')" :label-width="160">
          <lzDicSelect v-model="formData.relationship" dicType="PAPER_POLICY_RELATIONSHIP" :transfer="true">
          </lzDicSelect>
        </FormItem>
        <FormItem label="收件地址" prop="receiveAddress" :rules="$units.formRule.required('请输入收件地址')" class="full">
          <Input v-model="formData.receiveAddress" type="textarea" placeholder="请输入收件地址" />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit()" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicSelect from "@/components/commons/lzDicSelect";
import _ from 'lodash';
export default {
  components: {lzDicSelect},
  mixins: [common],
  props: [],
  data() {
    return {
      visible: false,
      loading: false,
      mobileEye: true,
      formData: {}
    };
  },
  created() {},
  methods: {
    // 信息修改
    dataChange(e) {
      this.$set(this.formData, 'receiveMoblie' ,e.target.value)
      this.mobileEye = false
    },
    openEye(item,keyName,name){
      let operationType
      if (name == 'receiveMoblie') {
        operationType = 2;
      } else if(name == 'receiveAddress'){
        operationType = 5;
      }
      if (!item[keyName]) {
        this.descrypt(
          {
            query: this.formData.orderNo,
            operationFunction: 40,
            operationType: operationType,
            otherInfo:{
              type:1
            }
          },
          item,
          name,
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    open() {
      this.formData = {};
      this.visible = true;
      this.loading = false;
      this.$nextTick(() => {
        // 清除验证信息
        this.$refs.form &&
          this.$refs.form.fields.forEach(item => {
            item.validateState = '';
            item.validateMessage = '';
          });
      });
    },
    // 获取保单数据
    getPolicy: _.debounce(function () {
      if (!this.formData.policyNo) {
        this.loadPolicy = true;
        return;
      }
      this.loadPolicy = false;
      this.$http({
        url: '/buz/policy/querySimpleByPolicyNo',
        type: 'POST',
        data: {
          isPaperPolicy: 1,
          policyNo: this.formData.policyNo
        }
      }).then(res => {
        this.loadPolicy = true;
        this.$set(this.formData, 'orgName', res.data.orgName);
        this.$set(this.formData, 'orderNo', res.data.orderNo);
        this.$set(this.formData, 'groupName', res.data.groupName);
        this.$set(this.formData, 'salesmanName', res.data.salesmanName);
        this.$set(this.formData, 'holderName', res.data.holderName);
        this.$set(this.formData, 'productName', res.data.productName);
        this.$set(this.formData, 'receiveName', res.data.contactName);
        this.$set(this.formData, 'receiveMoblie', res.data.contactMobile);
        this.$set(this.formData, 'receiveMoblie1', res.data.contactMobile1);
      });
    }, 500),
    submit() {
      if (!this.loadPolicy) {
        this.$notice.msg(this.formData.policyNo ? '保单校验中，请稍后重试' : '请输入保单号');
        return;
      }
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          url: '/buz/paperPolicy',
          data: formData
        })
          .then(res => {
            this.$notice.msg('纸质保单收件信息登记成功');
            this.$emit('reload');
            this.visible = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tips{
  display: flex;
}
</style>
